export default "__VITE_ASSET__f563a8bc__"